import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { costWith, costWithout } from '../../data/landing';
export function CostOfInaction() {
  return <section className="border-y border-line bg-surface px-5 py-16 md:py-24" data-id="element-81" data-mp="2qqsqn27uhmf6">
      <div className="mx-auto max-w-5xl" data-id="element-82" data-mp="2ls7p8zguwwp5">
        <h2 className="text-center text-4xl font-black uppercase leading-[1] tracking-tight text-heading md:text-6xl" data-id="element-83" data-mp="2gupohwcztns8">
          ¿Cuánto cuesta <span className="text-danger" data-id="element-84" data-mp="2cu5tozfw6w99">NO tenerlo?</span>
        </h2>

        <div className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-85" data-mp="282nt4chs6xot">
          <div className="rounded-3xl border border-line bg-ink p-6 md:p-8" data-id="element-86" data-mp="2812wmhbwp4ob">
            <p className="text-sm font-black uppercase tracking-[0.2em] text-danger" data-id="element-87" data-mp="2342rc8mvs5y9">Sin MegaPack</p>
            <ul className="mt-4 divide-y divide-line" data-id="element-88" data-mp="1y5j29zczqe1o">
              {costWithout.map(item => <li key={item} className="flex items-center gap-4 py-3.5" data-id="element-89" data-mp="1t5d92er2ojhh">
                  <XIcon className="h-5 w-5 shrink-0 text-danger" strokeWidth={2.5} aria-hidden="true" data-id="element-90" data-mp="1p3rzp3dqync1" />
                  <span className="font-medium text-body" data-id="element-91" data-mp="mdgvvenpeopr">{item}</span>
                </li>)}
            </ul>
          </div>
          <div className="rounded-3xl border border-success/40 bg-ink p-6 md:p-8" data-id="element-92" data-mp="r4yzybl0x5ey">
            <p className="text-sm font-black uppercase tracking-[0.2em] text-success" data-id="element-93" data-mp="cfj9kwpen1zs">Con MegaPack</p>
            <ul className="mt-4 divide-y divide-line" data-id="element-94" data-mp="hdkqpc39sr8m">
              {costWith.map(item => <li key={item} className="flex items-center gap-4 py-3.5" data-id="element-95" data-mp="153oubjggkqzm">
                  <CheckIcon className="h-5 w-5 shrink-0 text-success" strokeWidth={2.5} aria-hidden="true" data-id="element-96" data-mp="151lw4c55jrjt" />
                  <span className="font-bold text-heading" data-id="element-97" data-mp="1a0fbka401smm">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}